import React from "react";

function NoteFooter() {
  return (
    <div className="note-app__footer">
      <p>Copyright &#169; 2022, Neizar Kevin</p>
    </div>
  );
}

export default NoteFooter;
